import Image from 'components/Image';
import Link from 'next/link';
import React from 'react';
import extractText from 'utilities/src/extractText';

type GenericHeroType<T> = T | null | undefined;

type NodeType = {
  mediaDetails?: GenericHeroType<{
    file?: GenericHeroType<string>;
  }>;
  altText?: GenericHeroType<string>;
};

export type HeroProps = {
  post?: {
    slug?: GenericHeroType<string>;
    title?: GenericHeroType<string>;
    excerpt?: GenericHeroType<string>;
    categories?: GenericHeroType<{ nodes?: { name: string; slug: string }[] }>;
    featuredImage?: GenericHeroType<{
      node?: GenericHeroType<NodeType>;
    }>;
  };
};

function Hero({ post }: HeroProps) {
  return (
    <div className="overflow-hidden">
      {post?.categories?.nodes?.[0]?.name && (
        <Link
          href={`/category/${post?.categories?.nodes?.[0]?.slug ?? ''}/`}
          className="site-overline-m text-site-neutrals-500 hover:underline"
        >
          {post?.categories?.nodes?.[0]?.name}
        </Link>
      )}
      <Link href={post?.slug ?? '/'} className="flex h-full flex-col no-underline [&_strong]:hover:underline">
        <strong className="site-display-m text-site-neutrals-700 mb-2">{extractText(post?.title)}</strong>
        <span className="site-paragraph-xl text-site-neutrals-500 mb-6">{extractText(post?.excerpt)}</span>
        <figure className="relative flex-1">
          <Image
            src={post?.featuredImage?.node?.mediaDetails?.file ?? ''}
            alt={post?.featuredImage?.node?.altText ?? 'Featured image'}
            fill
            className="lgS:!absolute !relative object-cover"
            sizes="(max-width: 1280px) calc(100vw - 4rem), 55rem"
            priority
          />
        </figure>
      </Link>
    </div>
  );
}

export default Hero;
